import { createContext, useCallback, useContext, useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// In-app replacement for window.confirm / window.prompt.
// ask({ title, description, confirmLabel, danger, input: { placeholder, minLength, defaultValue, multiline, type } })
// resolves to true (confirm), the entered text (input), or null (cancelled).
const AskCtx = createContext(async () => null);
export const useAsk = () => useContext(AskCtx);

export const AskProvider = ({ children }) => {
  const [req, setReq] = useState(null);
  const [val, setVal] = useState("");
  const resolver = useRef(null);
  const ask = useCallback((r) => new Promise((resolve) => { resolver.current = resolve; setVal(r.input?.defaultValue || ""); setReq(r); }), []);
  const close = (result) => { resolver.current?.(result); resolver.current = null; setReq(null); };
  const inp = req?.input;
  const tooShort = inp && val.trim().length < (inp.minLength || 0);
  const field = "w-full rounded-lg border border-slate-300 px-3 text-[14px] outline-none focus:border-[#0E9384]";
  return (
    <AskCtx.Provider value={ask}>
      {children}
      <Dialog open={Boolean(req)} onOpenChange={(o) => !o && close(null)}>
        {req && (
          <DialogContent data-testid="ask-dialog" className="max-w-md">
            <DialogTitle className="font-display text-[20px] text-[#0B1B33]">{req.title}</DialogTitle>
            {req.description && <DialogDescription className="text-[14px] text-slate-600">{req.description}</DialogDescription>}
            <form onSubmit={(e) => { e.preventDefault(); if (!tooShort) close(inp ? val : true); }} className="space-y-4">
              {inp && (inp.multiline
                ? <textarea data-testid="ask-input" autoFocus rows={5} placeholder={inp.placeholder} value={val} onChange={(e) => setVal(e.target.value)} className={`${field} py-2.5`} />
                : <input data-testid="ask-input" autoFocus type={inp.type || "text"} placeholder={inp.placeholder} value={val} onChange={(e) => setVal(e.target.value)} className={`${field} h-11`} />)}
              {inp?.minLength > 0 && <p className="-mt-2 text-[12px] text-slate-500">At least {inp.minLength} characters.</p>}
              <div className="flex justify-end gap-2">
                <button type="button" onClick={() => close(null)} className="rounded-lg px-4 py-2.5 text-[14px] font-semibold text-slate-700 hover:bg-slate-100">Cancel</button>
                <button data-testid="ask-confirm" disabled={tooShort} className={`rounded-lg px-4 py-2.5 text-[14px] font-semibold text-white disabled:opacity-50 ${req.danger ? "bg-red-600 hover:bg-red-700" : "btn-teal"}`}>{req.confirmLabel || "OK"}</button>
              </div>
            </form>
          </DialogContent>
        )}
      </Dialog>
    </AskCtx.Provider>
  );
};
